import { FC } from 'react';
import { useMedia } from 'react-use';

import { Block, BlockHeader } from '../../../../../shared/lib/ui';
import S from './Abilities.module.scss';
import { useTranslation } from 'react-i18next';

export const Abilities: FC = () => {
  const { t, i18n } = useTranslation();
  const locale = i18n.resolvedLanguage;

  const isMobile = useMedia('only screen and (max-width: 743px)', false);

  return (
    <section>
      <BlockHeader
        block={t('webmaster.abilities_section.title')}
        title={t('webmaster.abilities_section.subtitle')}
      />

      <div className={S.Blocks}>
        <Block
          title={t('webmaster.abilities_section.card_1.title')}
          descr={t('webmaster.abilities_section.card_1.description')}
          img={`/assets/img/publishers/image-reports-${locale || 'ru'}.png`}
          size="small"
          color="white"
          imagePadding
          noImageBottomPadding
        />
        <Block
          title={t('webmaster.abilities_section.card_2.title')}
          descr={t('webmaster.abilities_section.card_2.description')}
          img={`/assets/img/publishers/image-tests-${locale || 'ru'}.png`}
          size="small"
          color="black"
          imgClass={S.ThirdBlockImg}
        />
      </div>
    </section>
  );
};
